module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showing) ? _c('div', {
    staticClass: "account",
    attrs: {
      "id": "account"
    }
  }, [_c('div', {
    staticClass: "account-inner"
  }, [(_vm.state === 'signin') ? _c('div', {
    staticClass: "sign-in"
  }, [_c('h2', [_vm._v("Sign In")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signInSubmit($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formemail),
      expression: "formemail"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "name": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.formemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formemail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formpassword),
      expression: "formpassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "name": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.formpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formpassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errormessage) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errormessage))]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [_vm._v("Sign In")])]), _vm._v(" "), _c('a', {
    staticClass: "forgotlink",
    on: {
      "click": function($event) {
        _vm.state = 'forgot'
      }
    }
  }, [_vm._v("Forgot your password?")]), _vm._v(" "), _c('h4', [_vm._v("New Users")]), _vm._v(" "), _c('p', [_vm._v("Create an account to save and manage your pullsheets")]), _vm._v(" "), _c('a', {
    staticClass: "signuplink",
    on: {
      "click": function($event) {
        _vm.state = 'signup'
      }
    }
  }, [_vm._v("Sign Up Now")])])]) : _vm._e()]), _vm._v(" "), (_vm.state === 'signup') ? _c('div', {
    staticClass: "sign-up"
  }, [_c('h2', [_vm._v("Sign Up")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('p', [_vm._v("Create an account to save and manage your pullsheets.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signUpSubmit($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formemail),
      expression: "formemail"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "name": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.formemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formemail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formpassword),
      expression: "formpassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "name": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.formpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formpassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errormessage) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errormessage))]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Account")])]), _vm._v(" "), _c('a', {
    staticClass: "goback",
    on: {
      "click": function($event) {
        _vm.state = 'signin'
      }
    }
  }, [_vm._v("Go Back")])])]) : _vm._e(), _vm._v(" "), (_vm.state === 'forgot') ? _c('div', {
    staticClass: "forgot"
  }, [_c('h2', [_vm._v("Reset Password")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('p', [_vm._v("Enter your email below and we'll send you a link with instructions to reset your password.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.resetSubmit($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formemail),
      expression: "formemail"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "name": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.formemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formemail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errormessage) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errormessage))]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('a', {
    staticClass: "goback",
    on: {
      "click": function($event) {
        _vm.state = 'signin'
      }
    }
  }, [_vm._v("Go Back")])])]) : _vm._e(), _vm._v(" "), (_vm.state === 'confirm') ? _c('div', {
    staticClass: "confirmation"
  }, [_c('h2', [_vm._v(_vm._s(_vm.confirmheader))]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('p', [_vm._v(_vm._s(_vm.confirmmessage))]), _vm._v(" "), _c('a', {
    staticClass: "goback",
    on: {
      "click": function($event) {
        _vm.state = 'signin'
      }
    }
  }, [_vm._v("Go Back")])])]) : _vm._e(), _vm._v(" "), (_vm.state === 'loggedin') ? _c('div', {
    staticClass: "loggedin"
  }, [_c('h2', [_vm._v("Account")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('p', [_vm._v("You are signed in as "), _c('strong', [_vm._v(_vm._s(_vm.user.email))]), _vm._v(".")]), _vm._v(" "), _c('a', {
    staticClass: "signout",
    on: {
      "click": function($event) {
        _vm.signOut()
      }
    }
  }, [_vm._v("Sign Out")])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-318e039e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account.vue
// module id = 186
// module chunks = 1